export const MINIMAL_BMI = 18.5;

export const codes = {
	FEMALE_PREGNANT_GETFIT: 'FEMALE_PREGNANT_GETFIT',
	FEMALE_PREGNANT_GETFIT_WARN: 'FEMALE_PREGNANT_GETFIT_WARN',
	UNDERWEIGHT: 'UNDERWEIGHT',
	UNDERWEIGHT_WARN: 'UNDERWEIGHT_WARN',
	OVERWEIGHT_GETFIT_WARN: 'OVERWEIGHT_GETFIT_WARN',
	OVERWEIGHT_WARN: 'OVERWEIGHT_WARN',
	OVERWEIGHT: 'OVERWEIGHT',
	NO_GOAL: 'NO_GOAL',
	GETTING_FIT: 'GETTING_FIT',
	GETTING_HEALTHIER: 'GETTING_HEALTHIER',
	REDUCE_WEIGHT_INVALID_WEIGHT_OR_BMI: 'REDUCE_WEIGHT_INVALID_WEIGHT_OR_BMI',
	REDUCE_WEIGHT_INVALID_BMI: 'REDUCE_WEIGHT_INVALID_BMI',
	REDUCE_WEIGHT_INITIAL_VALUE: 'REDUCE_WEIGHT_INITIAL_VALUE',
	REDUCE_WEIGHT_CUSTOM: 'REDUCE_WEIGHT_CUSTOM',
	REDUCE_WEIGHT: 'REDUCE_WEIGHT',
};

export default function validateBmi({
	calculatedBmi,
	calculateInitialBmi,
	isPregnant,
	isGettingFit,
	isGettingHealthier,
	acceptedWarningPregnant,
	acceptedWarningUnderweight,
	acceptedWarningOverweight,
	hasState,
	hasGoal,
	hasValidWeight,
	bmiIsValidToContinue,
	hasSuggestedReduceGoal,
	isCustomInput,
}: {
	calculatedBmi: number;
	calculateInitialBmi: number;
	isPregnant: boolean;
	isGettingFit: boolean;
	isGettingHealthier: boolean;
	acceptedWarningPregnant: boolean;
	acceptedWarningUnderweight: boolean;
	acceptedWarningOverweight: boolean;
	hasState: boolean;
	hasGoal: boolean;
	hasValidWeight: boolean;
	bmiIsValidToContinue: boolean;
	hasSuggestedReduceGoal: boolean;
	isCustomInput: boolean;
}) {
	const validToContinue: boolean = hasValidWeight && bmiIsValidToContinue;

	if (isGettingHealthier) {
		return codes.GETTING_HEALTHIER;
	}

	if (isPregnant && isGettingFit) {
		return acceptedWarningPregnant ? codes.FEMALE_PREGNANT_GETFIT_WARN : codes.FEMALE_PREGNANT_GETFIT;
	}

	if (calculatedBmi <= MINIMAL_BMI) {
		return acceptedWarningUnderweight ? codes.UNDERWEIGHT_WARN : codes.UNDERWEIGHT;
	}

	if (calculateInitialBmi >= 30) {
		if (isGettingFit && (acceptedWarningUnderweight || acceptedWarningOverweight)) {
			return codes.OVERWEIGHT_GETFIT_WARN;
		}

		if (calculatedBmi > MINIMAL_BMI && !isGettingFit && acceptedWarningOverweight) {
			return codes.OVERWEIGHT_WARN;
		}

		return codes.OVERWEIGHT;
	}

	if (!hasState || !hasGoal) {
		return hasGoal ? codes.REDUCE_WEIGHT : codes.NO_GOAL;
	}

	if (isGettingFit) {
		return codes.GETTING_FIT;
	}

	if (!validToContinue && !hasSuggestedReduceGoal) {
		return codes.REDUCE_WEIGHT_INVALID_WEIGHT_OR_BMI;
	}

	if (!bmiIsValidToContinue) {
		return codes.REDUCE_WEIGHT_INVALID_BMI;
	}

	if (hasSuggestedReduceGoal) {
		return !validToContinue && !isCustomInput ? codes.REDUCE_WEIGHT_INITIAL_VALUE : codes.REDUCE_WEIGHT_CUSTOM;
	}

	return codes.REDUCE_WEIGHT;
}
